import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { white, primary50, primary600, focusShadow, primary100, gray700, size16, size8, size48, duration150, easeInOut, primary200, primary400 } from '../../theme';
const Circle = styled.span`
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${primary100};
  color: ${gray700};
  display: flex;
  font-size: ${size16};
  font-family: fakt-normal, sans-serif;
  height: ${size48};
  justify-content: center;
  margin-bottom: ${size8};
  background: ${primary50};
  transition: border-color ${duration150} ${easeInOut},
    box-shadow ${duration150} ${easeInOut},
    background ${duration150} ${easeInOut};
  width: ${size48};
`;
const Button = styled.button`
  border-width: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
  width: 1px;

  ${props => !props.$active && css`
      &:hover {
        ~ ${Circle} {
          background: ${primary50};
        }
      }
    `}

  ${props => props.$active && css`
      &:disabled {
        ~ ${Circle} {
          border-color: ${primary200};
          background: ${primary200};
          color: ${primary400};
        }
      }
  
      ~ ${Circle} {
        color: ${white};
        background: ${primary600};
        border-color: ${primary600};
      }
    }
  `}

  ${props => !props.$active && css`
      &:disabled {
        ~ ${Circle} {
          border-color: ${primary100};
          background: ${primary50};
          color: ${primary200};
        }
      }
    `}

  &:focus {
    + ${Circle} {
      border-color: ${primary600};
      box-shadow: 0 0 0 3px ${focusShadow};
    }
  }
`;
const Label = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  text-align: center;
  ${({
  $disabled
}) => $disabled && 'pointer-events: none;'}
`;
export const WeekDaySelectorRadio = /*#__PURE__*/forwardRef(({
  name,
  label,
  value,
  disabled = false,
  index,
  onClick,
  dataTestId
}, ref) => {
  return /*#__PURE__*/React.createElement(Label, {
    $disabled: disabled,
    "data-testid": "label"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    "data-testid": `${dataTestId}-button`,
    onClick: () => {
      onClick(index);
    },
    $active: value.includes(index),
    name,
    disabled
  }), /*#__PURE__*/React.createElement(Circle, {
    "data-testid": `${dataTestId}-circle`,
    "aria-hidden": "true"
  }, label));
});
WeekDaySelectorRadio.displayName = 'WeekDaySelectorRadio';
export default WeekDaySelectorRadio;
//# sourceMappingURL=WeekDaySelectorRadio.js.map